import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import { debounce } from '@elliemae/ds-utilities/utils';
import DSTextBox from '@elliemae/ds-basic/form/TextBox';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var blockName = 'shuttle-search-box';
var SearchBoxContainer = aggregatedClasses('div')(blockName, null, function (_ref) {
  var isOpen = _ref.isOpen;
  return {
    opened: isOpen
  };
});
var filterList = debounce(function (term, onFilterCallback) {
  onFilterCallback(term);
}, 200);

var ShuttleSearchBox = /*#__PURE__*/function (_Component) {
  _inherits(ShuttleSearchBox, _Component);

  var _super = _createSuper(ShuttleSearchBox);

  function ShuttleSearchBox(props) {
    var _this;

    _classCallCheck(this, ShuttleSearchBox);

    _this = _super.call(this, props);
    _this.state = {
      value: props.value,
      prevProps: {}
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ShuttleSearchBox, [{
    key: "handleChange",
    value: function handleChange(e) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          filterOnKeyStroke = _this$props.filterOnKeyStroke,
          onFilter = _this$props.onFilter;
      var value = e.target.value;
      onChange(value);
      if (filterOnKeyStroke) filterList(value, onFilter);
      this.setState({
        value: value
      });
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      var onFilter = this.props.onFilter;
      if (e.keyCode === 13) onFilter(e.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      var _this$props2 = this.props,
          isOpen = _this$props2.isOpen,
          onClose = _this$props2.onClose,
          placeholder = _this$props2.placeholder;
      return /*#__PURE__*/React.createElement(SearchBoxContainer, {
        classProps: {
          isOpen: isOpen
        }
      }, /*#__PURE__*/React.createElement(DSTextBox, {
        autoFocus: true,
        clearable: true,
        onChange: this.handleChange,
        onClear: onClose,
        onKeyDown: this.handleKeyPress,
        placeholder: placeholder,
        value: value
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, _ref2) {
      var prevProps = _ref2.prevProps;
      var value = nextProps.value;

      if (value !== prevProps.value) {
        return {
          value: value,
          prevProps: {
            value: value
          }
        };
      }

      return null;
    }
  }]);

  return ShuttleSearchBox;
}(Component);

_defineProperty(ShuttleSearchBox, "defaultProps", {
  filterOnKeyStroke: false,
  onChange: function onChange() {
    return null;
  },
  onFilter: function onFilter() {
    return null;
  }
});

export default ShuttleSearchBox;
//# sourceMappingURL=ShuttleSearchBox.js.map
